import { render, staticRenderFns } from "./recoveryPassword.vue?vue&type=template&id=07123330&"
import script from "./recoveryPassword.vue?vue&type=script&lang=js&"
export * from "./recoveryPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports